import { z } from 'zod';

const planIdEnum = z.enum(['cosmic-navigator', 'cosmic-oracle']);
const billingCycleEnum = z.enum(['monthly', 'annual']);

export const createCheckoutSessionInputSchema = z.object({
  planId: planIdEnum.optional(),
  billingCycle: billingCycleEnum.optional(),
  couponId: z.string().min(1).optional(),
  locale: z.enum(['en', 'pt', 'es']).optional(),
  redirect: z.string().min(1).optional(),
  trackingData: z
    .object({
      fbp: z.string().optional(),
      fbc: z.string().optional(),
      gclid: z.string().optional(),
    })
    .optional(),
});

export type CreateCheckoutSessionInput = z.infer<typeof createCheckoutSessionInputSchema>;

export const createSetupSessionInputSchema = z.object({
  locale: z.enum(['en', 'pt', 'es']).optional(),
});

export type CreateSetupSessionInput = z.infer<typeof createSetupSessionInputSchema>;

export const updateSubscriptionInputSchema = z.object({
  planId: planIdEnum,
  billingCycle: billingCycleEnum,
});

export type UpdateSubscriptionInput = z.infer<typeof updateSubscriptionInputSchema>;

export const updateCustomerInfoSchema = z.object({
  email: z.string().email().optional(),
  name: z.string().min(1).optional(),
});

export type UpdateCustomerInfoInput = z.infer<typeof updateCustomerInfoSchema>;

export const cancelSubscriptionInputSchema = z.object({
  cancelAtPeriodEnd: z.boolean().default(true),
  reason: z.string().optional(),
});

export type CancelSubscriptionInput = z.infer<typeof cancelSubscriptionInputSchema>;
